import { inject, Injectable, InjectionToken, ValueProvider } from '@angular/core';
import { CanvasToolEntry } from '@panaya/ai-chat/shared';

const CANVAS_TOOLS = new InjectionToken<CanvasToolEntry[]>('The agent tools whose tool_start opens a canvas.');

/** Registers an agent tool whose `tool_start` opens a canvas; a host registers one per agent that shows a canvas. */
export function provideCanvasForTool(entry: CanvasToolEntry): ValueProvider {
    return { provide: CANVAS_TOOLS, useValue: entry, multi: true };
}

@Injectable({ providedIn: 'root' })
export class CanvasToolRegistry {
    private readonly entries = new Map((inject(CANVAS_TOOLS, { optional: true }) ?? []).map((entry) => [entry.tool, entry]));

    /** The registration for this tool name, or `null` when the tool opens no canvas. */
    public find(toolName: string): CanvasToolEntry | null {
        return this.entries.get(toolName) ?? null;
    }
}
